export class EditCollectionPointGroupAddCollectionPointsInput {
  groupId: number;
  collectionPoints: number[];

  constructor(groupId: number, collectionPoints: number[]) {
    this.groupId = groupId;
    this.collectionPoints = collectionPoints;
  }
}
